import isRemote from "Remote/isRemote";
import isProduction from "Utils/isProduction";

export const inIframe = () => {
  let inIframe;
  try {
    inIframe = window.self !== window.top;
  } catch (e) {
    inIframe = true;
  }
  return inIframe;
};

export const notInIframe = () => !inIframe();

const employerRoutesToCheck = ["/company/", "/employer-dashboard/", "/employer-renewal/", "/employer-application/", "/small-group/"];

// This is the ONLY "/small-group/" employee route.
const employeeMagicRoute = "/small-group/employee-dashboard";

const partnerBaseUrl = () => {
  if (isRemote()) {
    return isProduction ? "https://employ.remote.com" : "https://employ.niceremote.com";
  }
};

const partnerRedirectPath = () => {
  const { href } = window.location;
  const path = href.split(window.location.origin).at(-1);
  const deepLinkUrl = `deeplink_url=${path}`;
  const hasEmployerUrlPartial = employerRoutesToCheck.some((el) => deepLinkUrl.includes(el));
  const isNotEmployeeMagicRoute = !deepLinkUrl.includes(employeeMagicRoute);
  let partnerIframePath;
  // ER Redirect
  if (hasEmployerUrlPartial && isNotEmployeeMagicRoute) {
    if (isRemote()) {
      const partnerIdentifier = document.getElementById("data-partner-identifier");
      const { partnerId } = partnerIdentifier.dataset;
      partnerIframePath = `/dashboard/benefits/simply-insured/${partnerId}`;
    }
    // EE Redirect
  } else {
    if (isRemote()) {
      partnerIframePath = `/dashboard/benefits`;
    }
  }
  return partnerIframePath;
};

const redirectUrl = () => {
  return `${partnerBaseUrl()}${partnerRedirectPath()}`;
};

// Non-iframe pages that use the "/:partner/router" url structure.
const allowedUrlsOutsideIframe = [
  // This is pre-payroll sales prospects call to action page.
  "/router/payroll-prospect",
];

const iframeRequiredPartner = () => isRemote();
const iframeRequiredUrl = () => {
  const { href } = window.location;
  return !allowedUrlsOutsideIframe.some((el) => href.includes(el));
};
const iframeRequiredPage = () => iframeRequiredPartner() && iframeRequiredUrl();

const partnerIframeCheck = () => {
  try {
    if (notInIframe() && iframeRequiredPage()) {
      window.location = redirectUrl();
    }
  } catch (e) {
    console.log(e);
  }
};

export default partnerIframeCheck;
